import { AmendCpOrderSidePanel } from '../cpOrder/SidePanel';
import { connectAmendCpOrderSidePanel } from '../cpOrder/sidePanel.connect';

export const ConnectedAmendCpOrderSidePanel = connectAmendCpOrderSidePanel(AmendCpOrderSidePanel);
